module.exports = __webpack_public_path__ + "img/terms.c04720f1.jpg";